import React from 'react'
import Footer from '../Components/Footer'
import { AiOutlineCheck } from 'react-icons/ai'

const Thanks = () => {
  return (
    <>
    <div name='thanks' className='bg-white w-full h-full min-h-[calc(100vh-228px)] flex justify-center items-center p-4 pt-20 flex-col' >
            <AiOutlineCheck className='text-green-600 pb-6' size={80}/>
            <div className='font-medium text-2xl text-center'>Спасибо! Ваше сообщение было отправлено!
            <div className='flex justify-center gap-2 flex-wrap my-8'>
                <a href='/gallery' className='text-white border-2 text-lg bg-[#6C94D1] hover:bg-white hover:text-gray-500 hover:border-[#6C94D1] px-4 py-3 flex items-center'>Вернуться в галерею</a>
                <a href='/' className='text-white border-2 text-lg bg-[#6C94D1] hover:bg-white hover:text-gray-500 hover:border-[#6C94D1] px-4 py-3  flex items-center'>На главную</a>
            </div>
        </div>
    </div>
    <Footer />
    </>
  )
}

export default Thanks